module.exports = __webpack_public_path__ + "83e9d3d9753b53ca1f04c54edaf4590e.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/TN.svg
// module id = N/IZ
// module chunks = 0